export class Puppy {
  constructor(id, name, furColor, images, sex, salesStatus) {
    this.id = id;
    this.name = name;
    this.furColor = furColor;
    this.images = images;
    this.sex = sex;
    this.salesStatus = salesStatus;
  }
}